export default function ($translate) {
    return {
        KEYS: {
            MAGNUM: 'magnum',
            COURSY: 'coursy',
            TALLINN: 'tallinn',
            PRESENTERS: 'presenters'
        },
        LABELS: {
            coursy: $translate.instant('company.Coursy skin'),
            magnum: $translate.instant('company.Magnum skin'),
            tallinn: 'Tallinn',
            presenters: 'Presenters'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/company/skin/index.js